module.exports = __webpack_public_path__ + "static/media/badSmile.b727e959.svg";